//import GaugeChart from "react-gauge-chart";
import { Grid } from "@material-ui/core";
import "./Projects.scss";
import { Text, SelectBox, SVG } from "sunrise-ui";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { useState, useEffect } from "react";
import {
  getProjectData,
  getAllProjectData,
  getProjectFinancialDataByProject,
  getProjectPhysicalData,
  getProjectPilesInfo,
  getProjectFinancialDataByProjectIDAndDate,
  getProjectPhysicalDataByProjectIDAndDate,
  uiActions,
} from "../../redux/reducers/projectReducers";
import ProjectStatus from "./ProjectStatus";
import UserTimeSpent from "./UserTimeSpent";
import FinancialStatus from "./FinancialStatus";
import { DATA_NOT_FOUND } from "../../constants/globalConstants";
import {
  getPilesOverview,
  getPilesWIPOverview,
  getAllPiles,
} from "../../redux/reducers/pilesReducers";
import { getCompletedProjectData } from "../../redux/reducers/projectReducers";
import { maxValuesForBarChart } from "../../utilities/utils";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import FilterComponent from "../../components/helperComponents/FilterComponent";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

const displayDate = (dateString: string) => {
  if (dateString) {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "short" });
    const day = `0${date.getDate()}`.slice(-2);
    return `${day} ${month}, ${date.getFullYear()}`;
  }
  return "";
};
const RunningProjects = () => {
  // -------------------for running projects data-----------

  const dispatch = useDispatch<AppDispatch>();
  const allProjectData = useSelector(
    (state: any) => state.PROJECT.allProjectData
  );
  const projectData = useSelector((state: any) => state.PROJECT.projectData);
  const getFinancialData = useSelector(
    (state: any) => state.PROJECT.getFinancialDataByProject
  );
  const getFinancialDataByProjectAndDate = useSelector(
    (state: any) => state.PROJECT.getFinancialDataByProjectAndDate
  );
  // console.log(getFinancialDataByProjectAndDate)
  const physicalData = useSelector(
    (state: any) => state.PROJECT.getPhysicalInfo
  );
  const physicalDataByProjectAndDate = useSelector(
    (state: any) => state.PROJECT.physicalDataByProjectAndDate
  );
  
  const completedProjectData = useSelector(
    (state: any) => state.PROJECT.completedProjectData
  );
  const {
    completedPiles,
    completedDelayPiles,
    wipPiles,
    wipDelayPiles,
    discardRejectPiles,
  } = useSelector((state: any) => state.PROJECT.pilesInfo);

  const [projectList, setProjectList] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [projectName, setProjectName] = useState("");
  const [value, setValue] = useState({ from: "", to: "" });
  const [billingData, setBillingData]= useState<any>([]);
  const [projectPhysicalData, setprojectPhysicalData]= useState<any>([]);

  const [physicalDateValue, setPhysicalDateValue] = useState({ from: "", to: "" });
  //-------bar chart data------------
  const maxTotal: any = Math.max(
    ...physicalData?.map((val: any) => val?.total)
  );
  const barChartData = {
    labels: physicalData?.map((val: any) => val?.shortName),
    datasets: [
      {
        label: "Total Value",
        data: physicalData?.map((val: any) => val?.total),
        backgroundColor: physicalData?.map(() => "#5F67E0"),
      },
      {
        label: "Executed Value",
        data:
          projectPhysicalData.length > 0
            ? projectPhysicalData?.map((val: any) =>
                val?.total > 0 ? val?.executed : 0
              )
            : physicalData?.map((val: any) =>
                val?.total > 0 ? val?.executed : 0
              ),
        backgroundColor: physicalData?.map(() => "#FFD747"),
      },
    ],
  };
  const options = {
    esponsive: true,
    scales: {
      y: {
        min: 0,
        max: maxValuesForBarChart(maxTotal),
        stepSize: 1000,
      },
      x: {},
    },
  };

  const getPilesInfoData = (id: any) => {
    dispatch(
      getProjectPilesInfo({
        endPoint: `piles/pile-details-project-info?projectId=${id}`,
      })
    );
  };

  useEffect(() => {
    dispatch(
      getAllProjectData({
        endPoint: `project/get-all-projects`,
      })
    );

    dispatch(getCompletedProjectData({ endPoint: `project/completed` }));
  }, [dispatch]);

  useEffect(() => {
    if (allProjectData) {
      setProjectList(() => allProjectData.map((val: any) => val._id));
    }
  }, [projectList, allProjectData]);

  const runningProjectsData = allProjectData?.filter((val: any) => {
    return !completedProjectData?.find((val2: any) => {
      return val.projectName === val2.projectName;
    });
  });
  const projectsData: [] =
    runningProjectsData &&
    runningProjectsData?.map((item: any) => {
      return item?.projectName;
    });

  useEffect(() => {
    if (Array.isArray(runningProjectsData)) {
      let specificProject = runningProjectsData.filter(
        (item) => item._id === projectId && runningProjectsData[item._id]
      );
      setProjectList(specificProject[0]);
    }
  }, [runningProjectsData, projectId, projectList]);

  useEffect(() => {
    if (projectId) {
      dispatch(
        getProjectData({
          endPoint: `project/get-project/${projectId}`,
        })
      );
      getPilesInfoData(projectId);
    }
    // eslint-disable-next-line
  }, [projectId]);

  const reloadPileList = () => {
    dispatch(
      getAllPiles({
        endPoint: `piles?status=ALL&project=${projectId}`,
      })
    );
  };
  const resetFilter = ()=>{
    setValue({ from: "", to: "" });
    dispatch(uiActions.clearFinancialData())
    setBillingData([]);
    dispatch(
      getProjectFinancialDataByProject({
        endPoint: `project-finance/get-project-fin-by-projectId/${projectId}`,
      })
    );
  };
  const handleFilterDate = ()=>{
    dispatch(uiActions.clearFinancialData())
    if(projectId && value.to && value.from ){
      const toMonth = new Date(value.to).toLocaleString('default', { month: 'long' }).toLowerCase();
      const toYear = new Date(value.to).getFullYear();
      const fromMonth = new Date(value.from).toLocaleString('default', { month: 'long' }).toLowerCase();
      const fromYear = new Date(value.from).getFullYear();
      const toDate = new Date (`${toMonth} 1, ${toYear} 00:00:00`);
      const fromDate = new Date (`${fromMonth} 1, ${fromYear} 00:00:00`);
      dispatch(
        getProjectFinancialDataByProjectIDAndDate({
          endPoint: `project-finance/get-project-financial-by-projectIdAndDate?projectId=${projectId}&toDate=${toDate}&fromDate=${fromDate}`,
        })
      );
    }
  }

  const resetPhysicalFilter = ()=>{
    setPhysicalDateValue({ from: "", to: "" });
    setprojectPhysicalData([]);
  }

  const handlePhysicalFilterDate = ()=>{
    if(projectId && physicalDateValue.to && physicalDateValue.from ){
      console.log(physicalDateValue, projectId)
      const toMonth = new Date(physicalDateValue.to).toLocaleString('default', { month: 'long' }).toLowerCase();
      const toYear = new Date(physicalDateValue.to).getFullYear();
      const fromMonth = new Date(physicalDateValue.from).toLocaleString('default', { month: 'long' }).toLowerCase();
      const fromYear = new Date(physicalDateValue.from).getFullYear();
      const toDate = new Date (`${toMonth} 1, ${toYear} 00:00:00`);
      const fromDate = new Date (`${fromMonth} 1, ${fromYear} 00:00:00`);
      dispatch(
        getProjectPhysicalDataByProjectIDAndDate({
          endPoint: `project-physical/get-project-physical-by-projectIdAndDate?projectId=${projectId}&toDate=${toDate}&fromDate=${fromDate}`,
        })
      );
    }
  }

useEffect(()=>{
  if(physicalDataByProjectAndDate){
    setprojectPhysicalData(physicalDataByProjectAndDate)
  }
  },[physicalDataByProjectAndDate])
  
useEffect(()=>{
if(getFinancialDataByProjectAndDate){
  setBillingData(getFinancialDataByProjectAndDate[0])
}
},[getFinancialDataByProjectAndDate])
  useEffect(() => {
    if (projectId) {
      dispatch(
        getProjectFinancialDataByProject({
          endPoint: `project-finance/get-project-fin-by-projectId/${projectId}`,
        })
      );

      dispatch(
        getProjectPhysicalData({
          endPoint: `project-physical/get-physical-info/${projectId}`,
        })
      );

      dispatch(
        getPilesWIPOverview({
          endPoint: `piles/overview?status=IN_PROGRESS&project=${projectId}`,
        })
      );

      dispatch(
        getPilesOverview({
          endPoint: `piles/overview?status=OVERALL_STATS&project=${projectId}`,
        })
      );
      reloadPileList();
    }
    // eslint-disable-next-line
  }, [projectId, dispatch]);

  return (
    <Grid container>
      {/* ----------------total project box----------------- */}

      <Grid className="total_box bg--white box--shadow d-flex v-center">
        <Grid className="icon_container running_icon">
          <span className="iconify" data-icon="mdi:progress-clock"></span>
        </Grid>
        <Text
          type="normal"
          fonts="normal"
          fontSize={18}
          className="mb0 mt0 fw400"
        >
          Total Running Projects: {runningProjectsData.length}
        </Text>
      </Grid>
      {/* )} */}

      {/* -----------Running projects details main box-------------------------- */}
      <Grid container className="bg--white box--shadow p1 mt1">
        {/* ----project selection box----------- */}
        <Grid item xs={12}>
          <Grid className="standared_width">
            <SelectBox
              data={projectsData ? projectsData : DATA_NOT_FOUND}
              label="Select Running projects*"
              placeHolder="Select Project"
              defaultVal={projectName}
              // resetVal={projectName ? false : true}
              value={projectName}
              onChange={(e: any) => {
                setProjectName(e.target.value);
                const index = projectsData
                  ?.map((item: any) => item)
                  .indexOf(e.target.value);
                setProjectId(
                  runningProjectsData && runningProjectsData[index]?._id
                );
              }}
              borderColor={"primary"}
            />
          </Grid>
        </Grid>
        {projectName !== "" ? (
          <>
            {/* ----------------------smalll cards with small details 2nd Row--------- */}
            <Grid item xs={12}>
              <Grid container className="pt1">
                {/* ------Completed piles ontime--- */}
                <Grid className="p1 box--shadow small_info_card d-flex h-center v-center mr-1 mb1">
                  <Grid className="icon_container complete_icon mr">
                    <SVG type={"complete"} />
                  </Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt0 fw400 line-height1"
                  >
                    Completed piles
                    <br />
                    Till Date
                    <br />
                    (On-Time): {completedPiles}
                  </Text>
                </Grid>
                {/* ------completed piles delayed------- */}
                <Grid className="p1 box--shadow small_info_card d-flex h-center v-center mr-1 mb1">
                  <Grid className="icon_container delay_icon mr">
                    <SVG type={"delay"} />
                  </Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt0 fw400 line-height1"
                  >
                    Completed piles
                    <br />
                    Till Date
                    <br />
                    (Delayed): {completedDelayPiles}
                  </Text>
                </Grid>
                {/* ------WIP pile ontime------- */}
                <Grid className="p1 box--shadow small_info_card d-flex h-center v-center mr-1 mb1">
                  <Grid className="icon_container wip_icon mr">
                    <SVG type={"wip"} />
                  </Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt0 fw400 line-height1"
                  >
                    Work In Progress
                    <br />
                    Piles
                    <br />
                    (On-Time): {wipPiles}
                  </Text>
                </Grid>
                {/* ------WIP piles delayed------- */}
                <Grid className="p1 box--shadow small_info_card d-flex h-center v-center mr-1 mb1">
                  <Grid className="icon_container delay_icon mr">
                    <SVG type={"wipDelay"} />
                  </Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt0 fw400 line-height1"
                  >
                    Work In Progress
                    <br />
                    Piles
                    <br />
                    (Delayed): {wipDelayPiles}
                  </Text>
                </Grid>
                {/* ------Discarded Piles------- */}
                <Grid className="p1 box--shadow small_info_card d-flex h-center v-center mb1">
                  <Grid className="icon_container delay_icon mr">
                    <span
                      className="iconify text--danger"
                      data-icon="eva:close-fill"
                    ></span>
                  </Grid>

                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt0 fw400 line-height1"
                  >
                    Discarded Piles
                    <br />
                    Till Date
                    <br />
                    {discardRejectPiles}
                  </Text>
                </Grid>
              </Grid>
            </Grid>
            {/* --------------3rd row-------------------------------------- */}
            <Grid item xs={12}>
              <Grid container>
                {/* -------project status chart------ */}
                <ProjectStatus
                  totalPileLength={
                    projectData?.response?.workOrderInformation?.totalPileLength
                  }
                  completedPileLength={
                    projectData?.completedValues?.totalPileLength
                  }
                />
                {/* -----time spent till now chart----- */}
                <UserTimeSpent
                  fromDate={projectData?.response?.startDate}
                  toDate={projectData?.response?.expectedEndDate}
                />
                {/* -----project financial status chart----- */}
                <FinancialStatus
                  totalPaymentReceived={
                    billingData && billingData.paymentReceived
                      ? billingData.paymentReceived
                      : getFinancialData[0]?.paymentReceived
                  }
                  totalBillingDone={
                    billingData && billingData.billingDone
                      ? billingData.billingDone
                      : getFinancialData[0]?.billingDone
                  }
                  overallWorkDone={
                    billingData && billingData.workDone
                      ? billingData.workDone
                      : getFinancialData[0]?.workDone
                  }
                  workOrderValue={
                    projectData?.response?.workOrderInformation?.workOrderValue
                  }
                  setValue={setValue}
                  value={value}
                  handleFilterDate={handleFilterDate}
                  resetAll={resetFilter}
                />
              </Grid>
            </Grid>
            {/* ----------------last row-------------------------------------------- */}
            <Grid item xs={12}>
              <Grid container className="mt1">
                {/* ----------project info-------- */}
                <Grid item lg={4} xs={12}>
                  <Grid className="box--shadow p1 mr-1">
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={18}
                      className="mb1 mt0 fw500"
                    >
                      Project Information
                    </Text>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb1_5 mt0"
                    >
                      <Grid className="d-flex v-center w100">
                        <Grid className="icon_container project_name_icon mr">
                          <SVG type={"projectName"} />
                        </Grid>
                        <Grid className="w100">
                          <span className="fw400">Project Name</span>
                          <span className="fw500 float-right">
                            {projectData?.response?.projectName}
                          </span>
                        </Grid>
                      </Grid>
                    </Text>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb1_5 mt0"
                    >
                      <Grid className="d-flex v-center w100">
                        <Grid className="icon_container project_location_icon mr">
                          <SVG type={"projectLocation"} />
                        </Grid>
                        <Grid className="w100">
                          <span className="fw400">Project City</span>
                          <span className="fw500 float-right">
                            {projectData?.response?.projectCity}
                          </span>
                        </Grid>
                      </Grid>
                    </Text>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb1_5 mt0"
                    >
                      <Grid className="d-flex v-center w100">
                        <Grid className="icon_container client_icon mr">
                          <SVG type={"client"} />
                        </Grid>
                        <Grid className="w100">
                          <span className="fw400">Client</span>
                          <span className="fw500 float-right">
                            {projectData?.response?.clientInfo}
                          </span>
                        </Grid>
                      </Grid>
                    </Text>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb1_5 mt0"
                    >
                      <Grid className="d-flex v-center w100">
                        <Grid className="icon_container start_icon mr">
                          <SVG type={"start"} />
                        </Grid>
                        <Grid className="w100">
                          <span className="fw400">Project Started On</span>
                          <span className="fw500 float-right">
                            {displayDate(projectData?.response?.startDate)}
                          </span>
                        </Grid>
                      </Grid>
                    </Text>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb0 mt0"
                    >
                      <Grid className="d-flex v-center w100">
                        <Grid className="icon_container estimate_icon mr">
                          <SVG type={"estimate"} />
                        </Grid>
                        <Grid className="w100">
                          <span className="fw400">
                            Expected Completion Date
                          </span>
                          <span className="fw500 float-right">
                            {displayDate(
                              projectData?.response?.expectedEndDate
                            )}
                          </span>
                        </Grid>
                      </Grid>
                    </Text>
                  </Grid>
                </Grid>
                {/* ------project physical status chart------ */}
                <Grid lg={8} xs={12}>
                  <Grid container className="box--shadow p1">
                    <Grid item xs={12}>
                    <Grid className="d-flex v-center">
          <Text
            type="normal"
            fonts="normal"
            fontSize={18}
            className="mb0 mt0 fw500 px-1"
          >
            Project Physical Status
          </Text>
          <Grid>
                  <FilterComponent
                    handleFilterDate={handlePhysicalFilterDate}
                    setValue={setPhysicalDateValue}
                    value={physicalDateValue}
                    resetAll={resetPhysicalFilter}
                  />
          </Grid>
          </Grid>
                    </Grid>
                    {/* -------bar chart box------ */}
                    <Grid item xs={5}>
                      <Grid className="bar_char_box d-flex v-end mr-1">
                        <Bar data={barChartData} options={options} />
                      </Grid>
                    </Grid>
                    {/* ----------bar chart info box----- */}
                    <Grid item xs={7}>
                      <Grid>
                        <Text
                          type="normal"
                          fonts="normal"
                          fontSize={16}
                          className="mb1 mt0 fw500 w100"
                        >
                          <Grid container>
                            <Grid item xs={6}>
                              <span>Physical Parameter</span>
                            </Grid>
                            <Grid item xs={3}>
                              <span>Executed&nbsp;Value</span>
                            </Grid>
                            <Grid item xs={3}>
                              <span className="pl1">Total&nbsp;Value</span>
                            </Grid>
                          </Grid>
                        </Text>
                        <Grid className="scrollPhy">
                          {(projectPhysicalData && projectPhysicalData.length>0?projectPhysicalData:physicalData)?.map((val: any) => (
                            <Text
                              type="normal"
                              fonts="normal"
                              fontSize={16}
                              className="mb1 mt0 fw400 w100"
                            >
                              <Grid container>
                                <Grid item xs={6}>
                                  <span>
                                    {val.title}{" "}
                                    {val?.unit !== "na" && `(${val?.unit})`}
                                  </span>
                                </Grid>
                                <Grid item xs={4}>
                                  <span>
                                    {console.log(
                                      "VALUEES IN PROJECTSTATUS",
                                      val
                                    )}
                                    {val?.total ? val?.executed : "N/A"}
                                  </span>
                                </Grid>
                                <Grid item xs={2}>
                                  <span>{val?.total ? val?.total : "N/A"}</span>
                                </Grid>
                              </Grid>
                            </Text>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          <SelectOptionMsg
            text={`Select project to view Project information`}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default RunningProjects;
